import {createContext, useReducer, Dispatch, ReactNode} from 'react';

const initialState: StudentStateProps = {
	name: null,
	nameLatin: null,
	lastName: null,
	lastNameLatin: null,
	middleName: null,
	id: null,
	email: null,
	studentCode: null,
	studentAccountingNumber: null,
	telephone: null,
	commands: [],
	courseID: null,
	courseName: null,
	currentStatusID: null,
	currentStatusName: null,
	facultyID: null,
	facultyName: null,
	path: null,
	flowID: null,
	flowName: null,
	optionalSubjects: [],
	studentLyon3Number: null,
	imagePath: null,
	groupIDs: [],
	discount: null,
	progressDiscount: null,
	socialDiscount: null,
	otherDiscount: null,
	candidateID: null
};

export interface StudentStateProps {
	name: null | string;
	nameLatin: null | string;
	lastName: null | string;
	lastNameLatin: null | string;
	middleName: null | string;
	id: null | number;
	email: null | string;
	studentCode: null | string;
	studentAccountingNumber: null | string;
	telephone: null | string;
	commands: any[];
	courseID: null | number;
	courseName: null | string;
	path: string | null;
	currentStatusID: null | number;
	currentStatusName: null | string;
	facultyID: null | number;
	facultyName: null | string;
	flowID: null | number;
	flowName: null | string;
	optionalSubjects: any[];
	studentLyon3Number: null | string;
	imagePath: null | string;
	groupIDs: number[];
	discount: null | number;
	progressDiscount: null | number;
	socialDiscount: null | number;
	otherDiscount: null | number;
	candidateID: null | number;
}

type Action =
	| {type: 'LOGOUT'}
	| {
			type: 'SET_PROFILE';
			payload: StudentStateProps;
	  };

interface InitContextProps {
	state: StudentStateProps;
	dispatch: Dispatch<Action>;
}

export const StudentContext = createContext({} as InitContextProps);

const reducer = (state: StudentStateProps, action: Action) => {
	switch (action.type) {
		case 'SET_PROFILE':
			const newState: StudentStateProps = {
				// ...state,
				name: action.payload.name,
				nameLatin: action.payload.nameLatin,
				lastNameLatin: action.payload.lastNameLatin,
				lastName: action.payload.lastName,
				middleName: action.payload.middleName,
				telephone: action.payload.telephone,
				path: action.payload.path,
				id: action.payload.id,
				email: action.payload.email,
				studentCode: action.payload.studentCode,
				studentAccountingNumber: action.payload.studentAccountingNumber,
				commands: action.payload.commands,
				courseID: action.payload.courseID,
				courseName: action.payload.courseName,
				currentStatusID: action.payload.currentStatusID,
				currentStatusName: action.payload.currentStatusName,
				facultyID: action.payload.facultyID,
				facultyName: action.payload.facultyName,
				flowID: action.payload.flowID,
				flowName: action.payload.flowName,
				optionalSubjects: action.payload.optionalSubjects,
				studentLyon3Number: action.payload.studentLyon3Number,
				imagePath: action.payload.imagePath,
				groupIDs: action.payload.groupIDs,
				discount: action.payload.discount,
				progressDiscount: action.payload.progressDiscount,
				socialDiscount: action.payload.socialDiscount,
				otherDiscount: action.payload.otherDiscount,
				candidateID: action.payload.candidateID
			};

			return newState;
		case 'LOGOUT': {
			return initialState;
		}
		default:
			return state;
	}
};

const StudentProvider = ({children}: {children: ReactNode}) => {
	const [state, dispatch] = useReducer(reducer, initialState);
	const value = {state, dispatch};

	return <StudentContext.Provider value={value}>{children}</StudentContext.Provider>;
};

export default StudentProvider;
